import { Component, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { logout } from '../auth/auth.actions';
import { isLoggedIn, isLoggedOut, photoUrl } from '../auth/auth.selectors';
import { AppState } from '../state/state';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {

  // @ViewChild('navBurger') navBurger: ElementRef;
  // @ViewChild('navMenu') navMenu: ElementRef;
  isActiveStatus: boolean;

  isLoggedIn$: Observable<boolean>;
  isLoggedOut$: Observable<boolean>;

  pictureUrl$: Observable<string>

  isAuth: boolean;
  authSubscription: Subscription;



  constructor(
    private afAuth: AngularFireAuth,
    private store: Store<AppState>
    ) { }

  ngOnInit(): void {
    // this.afAuth.authState.subscribe(user => console.log(user));

    // this.store
    //   .subscribe(state => console.log('store value: ', state));

    this.isLoggedIn$ = this.store.pipe(
      select(isLoggedIn)
    );

    this.isLoggedOut$ = this.store.pipe(
      select(isLoggedOut)
    );
    
    this.pictureUrl$ = this.store.pipe(
      select(photoUrl)
      );
  }

  toggleNavbar() {
    // this.navBurger.nativeElement.classList.toggle('is-active');
    // this.navMenu.nativeElement.classList.toggle('is-active');
  }

  toggleClass() {
    this.isActiveStatus = !this.isActiveStatus;
    // return this.isActiveStatus;
  }

  onLogout() {
    this.afAuth.signOut()
      .then(() => this.store.dispatch(logout()));
  }



}
